import { ELSInlineLoader } from '@els/els-ui-common-react';
import cx from 'classnames';
import { ELSIconV2 } from 'components/common';
import LinkButton from 'components/common/link-button/LinkButton';
import Pill from 'components/common/pill/Pill';
var CentralizedLandingPageCard = function (_a) {
    var title = _a.title, description = _a.description, color = _a.color, icon = _a.icon, text = _a.text, loading = _a.loading, disabled = _a.disabled, onNavigation = _a.onNavigation, isSelected = _a.isSelected, _b = _a.iconColor, iconColor = _b === void 0 ? '' : _b, _c = _a.pillClassName, pillClassName = _c === void 0 ? '' : _c;
    return (<LinkButton onClick={onNavigation} type="container" disabled={disabled}>
    <div className={cx('c-centralized-landing-page__content-card', {
            'c-centralized-landing-page__content-card--disabled': disabled,
            'c-centralized-landing-page__content-card--selected': !disabled && isSelected
        })}>
      <div className={cx('c-centralized-landing-page__content-card-title', { 'c-centralized-landing-page__content-card-title--selected': isSelected })}>{title}</div>
      {loading ? (<ELSInlineLoader />) : (<div className="c-centralized-landing-page__content__pill-row-container">
          <Pill className={"c-centralized-landing-page__content__pill ".concat(pillClassName, " c-centralized-landing-page__content__pill--").concat(color)}>
            <ELSIconV2 id={icon} sprite={icon} size="xs" className={"u-custom-color-".concat(color, "-1 ").concat(iconColor, " c-centralized-landing-page__content__pill-icon")}/>
            <span className="c-centralized-landing-page__content__pill-text">{text}</span>
          </Pill>
          <p className="u-els-color-n9 c-centralized-landing-page__content__pill-description">{description}</p>
        </div>)}
    </div>
  </LinkButton>);
};
export default CentralizedLandingPageCard;
